<template>
  <div v-loading.body="loading">
    <el-row class="promotion-data">
      <el-form :model="promotionData" label-width="150px" ref="promotionData" :rules="rules">
        <el-form-item :label="generateCustomizeString('promotionName')" prop="title" style="margin-top: 50px;">
          <el-input v-model="promotionData.title" style="width: 300px;" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('endDate')" prop="expired_at" style="margin-top: 50px;">
          <el-date-picker
            v-model="promotionData.expired_at"
            type="datetime"
            :placeholder="generateCustomizeString('chooseDate')"
            style="width: 300px;"
          ></el-date-picker>
          <span style="margin-left: 10px; color: red;" v-if="isPromotionExpiredAtBeforeNow">{{ generateCustomizeString('eventHasExpired') }}</span>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('promotionGoodsListUrl')">
          <span style="color: #606266;" v-if="isEdit">
            <a
              :href="mobileUrl + '/full-reduction-promotion/' + this.promotionData.id"
              target="_blank"
            >{{mobileUrl + '/full-reduction-promotion/' + this.promotionData.id}}</a>
          </span>
          <span style="color: #606266;" v-if="!isEdit">http://</span>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('promotionGoodsListPCUrl')">
          <span style="color: #606266;" v-if="isEdit">
            <a
              :href="pcUrl + '/promotion/full-reduction/' + this.promotionData.id"
              target="_blank"
            >{{pcUrl + '/promotion/full-reduction/' + this.promotionData.id}}</a>
          </span>
          <span style="color: #606266;" v-if="!isEdit">http://</span>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('promotionDetail')" prop="threshold">
          <span style="margin-left: 20px;margin-right: 20px;">{{ generateCustomizeString('reach') }}</span>
          <el-input
            v-model="promotionData.full_threshold"
            style="width: 200px;"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
            @change="setTwoNumberDecimal()"
          >
            <template slot="prepend">NZD $</template>
          </el-input>
          <span style="margin-left: 20px;margin-right: 20px;">{{ generateCustomizeString('reduce') }}</span>
          <el-input
            v-model="promotionData.reduction"
            style="width: 200px;"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
            @change="setTwoNumberDecimalReduction()"
          >
            <template slot="prepend">NZD $</template>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top: 50px;">
          <el-button v-if="isEdit" type="primary" @click="updatePromotion()" plain>{{ generateCustomizeString('update') }}</el-button>
          <el-button v-if="!isEdit" type="primary" @click="createPromotion()" plain>{{ generateCustomizeString('create') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import dayjs from 'dayjs'
import { generateCustomizeString } from '@/utils/i18n'

const defaultPromotionData = {
  id: 0,
  title: '',
  shop_id: 0,
  full_threshold: null,
  reduction: null,
  expired_at: ''
}

export default {
  name: 'FullReductionPromotionDetails',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      promotionData: Object.assign({}, defaultPromotionData),
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL +
          this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url,
      rules: {
        title: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        expired_at: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    setTwoNumberDecimal(event) {
      if (this.promotionData.full_threshold) {
        this.promotionData.full_threshold = parseFloat(
          this.promotionData.full_threshold
        ).toFixed(2)
      } else {
        return ''
      }
    },
    setTwoNumberDecimalReduction(event) {
      if (this.promotionData.reduction) {
        this.promotionData.reduction = parseFloat(
          this.promotionData.reduction
        ).toFixed(2)
      } else {
        return ''
      }
    },
    fetchPromotionData() {
      request({
        url: 'activity/fullreduction/' + this.$route.params.promotionId,
        method: 'get'
      })
        .then(response => {
          this.promotionData = response.data
          if (response.data['full_threshold']) {
            this.promotionData.full_threshold = parseFloat(
              ((response.data['full_threshold'] / 100) * 1000) / 1000
            ).toFixed(2)
          }

          if (response.data['reduction']) {
            this.promotionData.reduction = parseFloat(
              ((response.data['reduction'] / 100) * 1000) / 1000
            ).toFixed(2)
          }

          // 转换时间
          if (response.data['expired_at']) {
            this.promotionData.expired_at = dayjs
              .utc(response.data['expired_at'], 'YYYY-MM-DD HH:mm:ss')
              .local()
              .toDate()
          } else {
            this.promotionData.expired_at = ''
          }

          console.log(this.promotionData)
        })
        .catch(error => {
          console.warn(error)
        })
    },
    createPromotion() {
      if (
        this.promotionData.full_threshold == null ||
        this.promotionData.reduction == null
      ) {
        this.$message.error(this.generateCustomizeString('enterFullReductionCondition'))
        return
      }
      if (
        Number(this.promotionData.full_threshold) <
        Number(this.promotionData.reduction)
      ) {
        this.$message.error(this.generateCustomizeString('enterFullReductionCondition'))
        return
      }

      let expired_at = ''
      if (this.promotionData.expired_at) {
        expired_at = dayjs(this.promotionData.expired_at)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      }

      var data = {}
      data = {
        title: this.promotionData.title,
        full_threshold: this.promotionData.full_threshold * 100,
        reduction: this.promotionData.reduction * 100,
        expired_at: expired_at
      }
      request({
        url: 'activity/fullreduction',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.push({
              name: 'FullReductionPromotion'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updatePromotion() {
      if (
        this.promotionData.full_threshold == null ||
        this.promotionData.reduction == null
      ) {
        this.$message.error(this.generateCustomizeString('enterFullReductionCondition'))
        return
      }
      if (
        Number(this.promotionData.full_threshold) <
        Number(this.promotionData.reduction)
      ) {
        this.$message.error(this.generateCustomizeString('enterFullReductionCondition'))
        return
      }

      let expired_at = ''
      if (this.promotionData.expired_at) {
        expired_at = dayjs(this.promotionData.expired_at)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      }

      var data = {}
      data = {
        title: this.promotionData.title,
        full_threshold: this.promotionData.full_threshold * 100,
        reduction: this.promotionData.reduction * 100,
        expired_at: expired_at
      }
      request({
        url: 'activity/fullreduction/' + this.$route.params.promotionId,
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'FullReductionPromotion'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    }
  },
  created: function() {
    if (location.host.includes('ieshop.co.nz')) {
      const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
      if (this.pcUrl.includes('nzmai.com.cn')) {
        this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
      }
    }
    if (this.isEdit) {
      this.fetchPromotionData()
    } else {
      this.promotionData = Object.assign({}, defaultPromotionData)
    }
  },
  computed: {
    isPromotionExpiredAtBeforeNow: function() {
      if (this.promotionData.expired_at) {
        return dayjs(this.promotionData.expired_at).isBefore(dayjs())
      } else {
        return false
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.promotion-data {
  padding: 80px 60px 0px 50px;
}
</style>
